
import * as z from "zod";

export const calculatorContactFormSchema = z.object({
  naam: z.string().min(1, "Naam is verplicht"),
  bedrijf: z.string().min(1, "Bedrijf is verplicht"),
  email: z.string().email("Voer een geldig e-mailadres in"),
  telefoonnummer: z.string().min(1, "Telefoonnummer is verplicht"),
});

export type CalculatorContactFormValues = z.infer<typeof calculatorContactFormSchema>;
